import React, { useState } from 'react'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import TabsComponent from './TabsComponent';
import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';
import { Box, Typography } from '@mui/material';
import Header from './Header';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

function SkillBuilder() {
  const textDarkGrey = "rgb(145,145,145)"
  const getDataFromCookie = getCookie("data")
  const getDataBeforeFromCookie = getCookie("dataBefore")
  const dataArr = getDataFromCookie === null ? [4, 7, 3, 5, 4, 3] : [...getDataFromCookie.split(",", 6).map(n => +n)]
  const dataBeforeArr = getDataBeforeFromCookie === null ? [4, 7, 3, 5, 4, 3] : [...getDataBeforeFromCookie.split(",", 6).map(n => +n)]
  const [data, setData] = useState({
    labels: ['Active Listening', 'Written Communication', 'Speaking', 'Problem Solving', 'Creative Thinking', 'Mindfulness'],
    datasets: [
      {
        label: 'Teacher',
        data: dataBeforeArr,
        backgroundColor: 'rgba(140, 199, 59, 0.2)',
        borderColor: 'rgba(140, 199, 59, 1)',
        borderWidth: 1,
      },
      {
        label: 'Self',
        data: dataArr,
        backgroundColor: 'rgba(86, 167, 174, 0.2)',
        borderColor: 'rgba(86, 167, 174, 1)',
        borderWidth: 1,
      },
    ],
  });
  const [selectedColor, setSelectedColor] = useState("198, 16, 82")
  const [collapsed, setCollapsed] = useState(false)


  var options = {
    scale: {
      r: {
        max: 10,
        min: 0,
      },
    },

  };

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  function setCookie(cname, cvalue) {
    const d = new Date();
    document.cookie = cname + "=" + cvalue + ";" + ";path=/";
  }

  const changeData = (arr) => {
    let getCookieData = getCookie("data")
    let tempDataArr = [...getCookieData.split(",", 6).map(n => +n)]

    setData(prev => {
      return {
        labels: ['Active Listening', 'Written Communication', 'Speaking', 'Problem Solving', 'Creative Thinking', 'Mindfulness'],
        datasets: [
          {
            label: 'Teacher',
            data: dataBeforeArr,
            backgroundColor: 'rgba(140, 199, 59, 0.2)',
            borderColor: 'rgba(140, 199, 59, 1)',
            borderWidth: 1,
          },
          {
            label: 'Self',
            data: tempDataArr,
            backgroundColor: 'rgba(86, 167, 174, 0.2)',
            borderColor: 'rgba(86, 167, 174, 1)',
            borderWidth: 1,
          },
        ],
      }
    })
  }

  return (
    <>
      <Header />
      <Box sx={{
        display: "flex",
        width: "100%",
        height: "90vh"
      }}>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "60%",
          marginBottom: "20px",
          padding: "2.5rem"
        }}>
          <Typography variant="h4" sx={{ color: textDarkGrey, fontWeight: "bold", marginBottom: "20px" }}>Skill Builder</Typography>
          {/* <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}> */}
          <TabsComponent changeData={changeData} setSelectedColor={setSelectedColor} />
          {/* {collapsed ? <WestIcon sx={{ color: textDarkGrey, fontSize: "30px" }} onClick={() => setCollapsed(false)} /> : <EastIcon sx={{ color: textDarkGrey, fontSize: "30px" }} onClick={() => setCollapsed(true)} />} */}
          {/* </Box> */}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "40%", borderLeft: "3px solid rgb(145,145,145)" }}>
          <Radar data={data} options={options} />
        </Box>

      </Box>
    </>
  )
}

export default SkillBuilder